
import Vue from "vue";

export default Vue.extend({
  name: "component-portal-card-header",
  props: {
    iconSize: {
      type: Number,
      default: 14.5,
    },
    width: {
      type: Number,
      default: 184.62,
    },
    height: {
      type: Number,
      default: 29.99,
    },
    fontSize: {
      type: Number,
      default: 13,
    },
  },
  computed: {
    iconSrc(): string {
      return require("@/assets/images/warning-yellow.svg");
    },
    title(): string {
      return this.$i18n.t("CardView.evacuationDrill.cardHeaderTitle").toString();
    },
  },
});
